/*
 * Ported verbatim from the legacy app's scripts/app/components/isotope.js.
 * Relies on the global `jQuery` shim set up in main.js and the Isotope
 * jQuery bridge (imported before this module).
 */

(function ($) {

    $(function () {
        if ($('.grid').length) {
            var qsRegex;
            var buttonFilter = '.employee';

            // init Isotope
            var $grid = $('.grid').isotope({
                itemSelector: '.grid-item',
                layoutMode: 'fitRows',
                percentPosition: true,
                filter: function () {
                    var $this = $(this);
                    var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
                    var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
                    return searchResult && buttonResult;
                },
                getSortData: {
                    name: '.headline',
                    lastname: '.lastname'
                },
                sortBy: 'lastname'
            });

            // filter items on button click
            $('.filter-button-group').on('click', 'button', function () {
                buttonFilter = $(this).attr('data-filter');
                $('.filter-button-group').find('.btn').removeClass('btn-primary');
                $(this).addClass('btn-primary');
                $('#js-athletes-filter').val(buttonFilter);
                $('#quicksearch').val('');
                qsRegex = '';
                $grid.isotope();
            });

            // filter items on dropdown select
            $('#js-athletes-filter').on('change', function () {
                buttonFilter = this.value;
                $('.filter-button-group').find('.btn').removeClass('btn-primary');
                $('.filter-button-group').find('[data-filter="' +buttonFilter+'"]').addClass('btn-primary');
                $('#quicksearch').val('');
                qsRegex = '';
                $grid.isotope();
            });


            // use value of search field to filter
            var $quicksearch = $('#quicksearch').keyup(debounce(function () {
                qsRegex = new RegExp($quicksearch.val(), 'gi');
                $grid.isotope();
            }));


        }

        // debounce so filtering doesn't happen every millisecond
        function debounce(fn, threshold) {
            var timeout;
            threshold = threshold || 100;
            return function debounced() {
                clearTimeout(timeout);
                var args = arguments;
                var _this = this;
                function delayed() {
                    fn.apply(_this, args);
                }
                timeout = setTimeout(delayed, threshold);
            };
        }
    });

})(window.jQuery);
